<template>
    <div class="page">
        <div class="header-section">
            <h2 class="page-title">LTR Kalkulacije - Podešavanja</h2>
            <p class="page-subtitle">Upravljanje default vrednostima za kalkulacije</p>
        </div>

        <div class="settings-container">
            <div class="alert alert-info mb-4">
                <i class="bi bi-info-circle"></i>
                Ove vrednosti se koriste kao podrazumevane pri kreiranju novih LTR kalkulacija.
            </div>

            <div v-if="loading" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Učitavanje...</span>
                </div>
            </div>

            <div v-else class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>Naziv</th>
                            <th>Vrednost</th>
                            <th>Akcije</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in defaults" :key="item.key">
                            <td>
                                <strong>{{ item.description }}</strong>
                                <br>
                                <small class="text-muted">{{ item.key }}</small>
                            </td>
                            <td>
                                <span v-if="!item.editing">{{ item.value }}</span>
                                <input v-else type="number" step="0.01" class="form-control form-control-sm"
                                    v-model="item.editValue" @keyup.enter="saveItem(item)"
                                    @keyup.esc="cancelEdit(item)" />
                            </td>
                            <td>
                                <button v-if="!item.editing" class="btn btn-sm btn-primary me-2"
                                    @click="editItem(item)">
                                    <i class="bi bi-pencil"></i> Izmeni
                                </button>
                                <template v-else>
                                    <button class="btn btn-sm btn-success me-2" @click="saveItem(item)">
                                        <i class="bi bi-check"></i> Sačuvaj
                                    </button>
                                    <button class="btn btn-sm btn-secondary" @click="cancelEdit(item)">
                                        <i class="bi bi-x"></i> Otkaži
                                    </button>
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import LtrCalculationDefaultsService from "../../services/ltr-calculation-defaults.service";

export default {
    name: "ltr-defaults-settings",
    data() {
        return {
            defaults: [],
            loading: true,
        };
    },
    methods: {
        async loadDefaults() {
            this.loading = true;
            try {
                const { data } = await LtrCalculationDefaultsService.getAll();
                this.defaults = data.map(item => ({
                    ...item,
                    editing: false,
                    editValue: item.value
                }));
            } catch (error) {
                console.error('Error loading defaults:', error);
                this.$store.commit("app/showAlert", {
                    type: "danger",
                    message: "Greška pri učitavanju podešavanja: " + (error.response?.data?.message || error.message)
                });
            } finally {
                this.loading = false;
            }
        },

        editItem(item) {
            item.editing = true;
            item.editValue = item.value;
        },

        cancelEdit(item) {
            item.editing = false;
            item.editValue = item.value;
        },

        async saveItem(item) {
            try {
                await LtrCalculationDefaultsService.update(item.key, { value: item.editValue });
                item.value = item.editValue;
                item.editing = false;
                this.$store.commit("app/showAlert", {
                    type: "success",
                    message: "Vrednost uspešno ažurirana."
                });
            } catch (error) {
                console.error('Error updating default:', error);
                this.$store.commit("app/showAlert", {
                    type: "danger",
                    message: "Greška pri čuvanju: " + (error.response?.data?.message || error.message)
                });
            }
        },
    },
    mounted() {
        this.loadDefaults();
    },
};
</script>

<style scoped>
.page {
    max-width: 1200px;
    margin: 30px auto;
    padding: 0 20px;
}

.header-section {
    margin-bottom: 2rem;
}

.page-title {
    font-size: 1.75rem;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 0.5rem;
}

.page-subtitle {
    color: #6b7280;
    font-size: 1rem;
    margin: 0;
}

.settings-container {
    background-color: #ffffff;
    border-radius: 0.75rem;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    padding: 2rem;
}

.table {
    margin-bottom: 0;
}

.table thead th {
    background-color: #f9fafb;
    border-bottom: 2px solid #e5e7eb;
    font-weight: 600;
    color: #374151;
    padding: 1rem;
}

.table tbody td {
    padding: 1rem;
    vertical-align: middle;
}

.table-hover tbody tr:hover {
    background-color: #f9fafb;
}

.alert {
    border-radius: 0.5rem;
    padding: 1rem 1.25rem;
}

.alert-info {
    background-color: #dbeafe;
    border-color: #bfdbfe;
    color: #1e40af;
}

.alert i {
    margin-right: 0.5rem;
}
</style>
